import "./vaults.css";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

import { apiUrl } from "../../config";
import SetTitle from "../../components/setTitle/SetTitle";
import VoteDlg from "../../dialogues/voteDlg/VoteDlg";
import PendingRequests from "../../components/vaults/pendingRequests/PendingRequests";
import Button from "@mui/material/Button";
import Login from "../login/Login";

const vaultsUrl = apiUrl + "vaults/";

export default function Vaults(props) {
  SetTitle("Vaults @ DefiWatch.biz");

  const [isLoading, setIsLoading] = useState(true);
  const [vaultsByPlatform, setVaultsByPlatform] = useState({});

  const [dialogData, setDialogData] = useState({});

  const [open, setOpen] = useState(false);
  const handleClickOpen = (evt) => {
    const rowJsonStr = evt.target.getAttribute("data-row");
    setDialogData(JSON.parse(rowJsonStr));

    setOpen(true);
  };

  useEffect(() => {
    const getDefiData = async () => {
      try {
        setIsLoading(true);

        console.log(vaultsUrl); // + dateRange
        const res = await axios.get(vaultsUrl, {
          /*headers: {
            token:
            "Bearer "+JSON.parse(localStorage.getItem("user")).accessToken,
          },*/
        });
        setVaultsByPlatform(res.data);

        setIsLoading(false);
      } catch (err) {
        console.log(err);
      }
    };
    getDefiData();
  }, []);

  function getAuto(platform) {
    return platform == "Autofarm"
      ? "Auto"
      : [
          "Growthdefi",
          "Tarot",
          "Hector",
          "AlphaHomora2",
          "Wonderland",
          "Saber",
          "Orca",
          "Port",
          "Anchorprotocol",
          "Exchange",
          "Kava",
          "8ight",
        ].includes(platform)
      ? "Manual"
      : "Semiauto";
  }

  return (
    <div className="page vaultsPage">
      <div className="topSubMenu">
        <h1>Vaults</h1>
        {/* <Button
          variant="outlined"
          className="extraSmall"
          // startIcon={<LocalAtmOutlinedIcon />}
        >
          Request to Add <label className="vaultBadge">Auto</label> Vault
        </Button> */}

        {props.userAuthWallet ? (
          <Link to="/vaults/add" className="link">
            <Button
              variant="outlined"
              className="extraSmall"
              // startIcon={<LocalAtmOutlinedIcon />}
            >
              Add <label className="vaultBadge vaultManual">Manual</label> Vault
            </Button>
          </Link>
        ) : (
          <Login />
        )}
      </div>

      {isLoading ? <h2>Loading...</h2> : <></>}

      <div className="divVaults">
        <div className="legend">
          <ul>
            <li>
              <label className="vaultBadge">Auto</label> - All balances and
              rewards are pulled up automatically.
            </li>
            <li>
              <label className="vaultBadge vaultSemiauto">Semiauto</label> - For
              automatic processing, the vault must be added manually.
            </li>
            <li>
              <label className="vaultBadge vaultManual">Manual</label> - The
              addition of this platform has been postponed to a later date. For
              now, you can enter balances and rewards manually.
            </li>
          </ul>
        </div>

        <PendingRequests
          userAuthWallet={props.userAuthWallet}
          handleClickOpen={handleClickOpen}
        />

        <h2>Supported Vaults</h2>

        {Object.keys(vaultsByPlatform).map((platform) => {
          return (
            <div className="vault" key={platform}>
              <h2>
                {platform}{" "}
                {/* {platform == "Autofarm" ? (
                  <label className="vaultBadge">Auto</label>
                ) : [
                    "Growthdefi",
                    "Tarot",
                    "Hector",
                    "AlphaHomora2",
                    "Wonderland",
                    "Saber",
                    "Orca",
                    "Port",
                    "Anchorprotocol",
                    "Exchange",
                    "Kava",
                    "8ight",
                  ].includes(platform) ? (
                  <label className="vaultBadge vaultManual">Manual</label>
                ) : (
                  <label className="vaultBadge vaultSemiauto">Semiauto</label>
                )} */}
                {
                  <label className={"vaultBadge vault" + getAuto(platform)}>
                    {getAuto(platform)}
                  </label>
                }
              </h2>

              {getAuto(platform) == "Auto" ? (
                <p>
                  All balances and rewards for all vaults of <b>{platform}</b>{" "}
                  are pulled up automatically.
                </p>
              ) : getAuto(platform) == "Semiauto" ? (
                <p>
                  For automatic processing, the vault must be added manually.
                  Below is a list of already added vaults. To add other{" "}
                  <b>{platform}</b> vaults for automatic processing, please make
                  a request.
                </p>
              ) : (
                ""
              )}

              {Object.keys(vaultsByPlatform[platform]).map((blockchain) => {
                return (
                  <div key={blockchain}>
                    <h3>{blockchain}</h3>
                    <ul>
                      {vaultsByPlatform[platform][blockchain].map((vault) => {
                        return (
                          <li key={vault.assetId}>
                            {vault.assetId}. {vault.Vault}{" "}
                            {vault.Uses ? "(" + vault.Uses + ")" : ""}{" "}
                            <label className={"vaultBadge vault" + vault.auto}>
                              {vault.auto}
                            </label>
                            {getAuto(platform) == "Semiauto" &&
                            vault.auto == "Manual" ? (
                              props.userAuthWallet ? (
                                <Button
                                  variant="outlined"
                                  className="extraSmall reqBtn"
                                  // startIcon={<LocalAtmOutlinedIcon />}
                                  data-row={JSON.stringify({
                                    id: vault.assetId,
                                    vault: vault.Vault,
                                  })}
                                  // data-row={vault}
                                  onClick={handleClickOpen}
                                >
                                  Ask to make it{" "}
                                  <label className="vaultBadge">Auto</label>{" "}
                                  Vault
                                </Button>
                              ) : (
                                <span className="toSeeBtnConnectMetamask">[ Connect to Metamask to Add/Vote ]</span>
                              )
                            ) : (
                              ""
                            )}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                );
              })}

              {/* {getAuto(platform) == "Semiauto" ? (
                <Button
                  variant="outlined"
                  className="extraSmall semiautoBlockBtn"
                  // startIcon={<LocalAtmOutlinedIcon />}
                >
                  Request to Add Another {platform + " "}
                  <label className="vaultBadge">Auto</label> Vault
                </Button>
              ) : (
                ""
              )} */}
            </div>
          );
        })}

        <VoteDlg
          userAuthWallet={props.userAuthWallet}
          balanceDw={props.balanceDw}
          dialogData={dialogData}
          open={open}
          setOpen={setOpen}
        />
      </div>
    </div>
  );
}
